module.exports = function makeString(object) {
  if (object == null) return "";
  return "" + object;
};
